<ds24-toast
  *ngFor="let toastItem of messages; let i = index"
  [toastItem]="toastItem"
  (toastClose)="removeItem(i)"
  @items
>
</ds24-toast>
